import {
    ChangeDetectionStrategy,
    Component,
    ViewEncapsulation,
    computed,
    input,
} from "@angular/core";
import { MatIconModule } from "@angular/material/icon";

/** Number of shades in $avatar-colors (colors.scss); keep the two in step. */
const AVATAR_COLOR_COUNT = 5;

/**
 * One avatar circle: either a person, shown as initials on a background color derived
 * from their name, or an icon — the shape a group uses for its "add user" affordance.
 */
@Component({
    selector: "app-cerrix-avatar",
    imports: [MatIconModule],
    templateUrl: "./cerrix-avatar.component.html",
    styleUrl: "./cerrix-avatar.component.scss",
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CerrixAvatarComponent {
    /** Full name of the person. Its initials and background color are derived from it. */
    readonly name = input("");

    /** Renders this icon instead of initials — pass an icon registered in app.component.ts. */
    readonly icon = input("");

    protected readonly initials = computed(() => {
        const words = this.name().trim().split(/\s+/).filter(Boolean);
        if (words.length === 0) {
            // A user without a name still has to read as a person, not as an empty circle.
            return "?";
        }

        const first = words[0][0];
        const last = words.length > 1 ? words[words.length - 1][0] : "";
        return (first + last).toUpperCase();
    });

    /**
     * Either one of the $avatar-colors classes or the outlined look of the icon variant.
     * Hashing the name means the same person keeps the same color on every screen.
     */
    protected readonly variant = computed(() => {
        if (this.icon()) {
            return "outlined";
        }

        const hash = [...this.name()].reduce((sum, char) => sum + char.charCodeAt(0), 0);
        return `color-${hash % AVATAR_COLOR_COUNT}`;
    });
}
